import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap'

import CheckCard from './CheckCard';
import Error from "./common/Error";

import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

import { useTranslation } from 'react-i18next';
import { contains, floorTens, isEmpty } from "../Util";
import Layout from "./common/Layout";
import { cancelTransaction, getStrongVerificationOptions, setTransactionAgreement } from "../store/Actions";
import Loader from "./common/Loader";
import i18next from "i18next";

import { useNavigate } from "react-router-dom";
import Back from "./common/Back";

const CheckOptions = () => {

    const [isResourceLoaded, setIsResourceLoaded] = useState(false)
    const [showGdprMessageMandatory, setShowGdprMessageMandatory] = useState(false)

    const [selectedOption,setSelectedOption] = useState(null);

    const error = useSelector((state) => state.Reducer.error)
    const options = useSelector((state) => state.Reducer.options)
    const termsOfPayment = useSelector((state) => state.Reducer.settings?.termsOfPayment)
    const IsGDPRAccepted = useSelector((state) => state.Reducer.IsGDPRAccepted)
    const isTransactionProcessing = useSelector((state) => state.Reducer.isTransactionProcessing)
    const getPrivacyNoticeUrl = ()=>{

        switch(i18next.language){

            case('fr'):
                return process.env.REACT_APP_PRIVACY_NOTICE_FR
            case('it'):
                return process.env.REACT_APP_PRIVACY_NOTICE_IT
            default : 
                return process.env.REACT_APP_PRIVACY_NOTICE
        }
    }

    const currentPrivacyNoticeUrl = getPrivacyNoticeUrl()

    useEffect(() => {
        const loadOptions = async () => {
            if (isEmpty(options))
                await getStrongVerificationOptions();
            setIsResourceLoaded(() => true)
        }      
        loadOptions();           
    }, [])

    useEffect(() => {      
        window.addEventListener("beforeunload", cancelTransaction);
        return () => window.removeEventListener("beforeunload", cancelTransaction);
    }, []);

    const handleGdprAgreement = (event) => {
        event.target.disabled = true
        setShowGdprMessageMandatory(false)
        setTransactionAgreement(() => event.target.disabled = false)
    }

    const navigate = useNavigate();

    const handleCardSelect = (navigateTo) => {
        setSelectedOption(navigateTo);
        setShowGdprMessageMandatory(false);
    }

    const handleContinue = () => {

       if(IsGDPRAccepted && selectedOption)
       {
            navigate(selectedOption)
       }else{
            setShowGdprMessageMandatory(true);
       }
    }
 
    const { t } = useTranslation();

    return (
        <Layout isLarge={true}>

           
            <div className="az-pay-title">
                {t("checkOptions.verify.title")}
                {isTransactionProcessing && isEmpty(error) && 
                    <>
                        <span className="az-pay-card-clock">
                            <img src={process.env.PUBLIC_URL + 'images/clock.svg'}/>
                            <span className="ms-2">{t('checkOptions.estimatedTime.label')}</span>
                        </span>
                    </>
                }
            </div>
            
            

            { isTransactionProcessing &&
                <div className="az-pay-subtitle">    
                    {t("checkOptions.termsOfPayment.text", { termsOfPayment : floorTens(termsOfPayment) })}
                </div>
            }              

            <Loader loading={!isResourceLoaded} message={t('checkOptions.loading.text')}/>

            <Error renderer={!isTransactionProcessing} message={t('checkOptions.error.text')}/>

            { isTransactionProcessing && isResourceLoaded && isEmpty(error) && !isEmpty(options) &&
                <div className="row justify-content-md-center">
                    <CheckCard renderer={contains(options, "IdCheck")}
                        name={t("checkOptions.card.IdVerification.title")} 
                        description={t("checkOptions.card.IdVerification.desc")}
                        description2={t("checkOptions.card.IdVerification.desc2")} 
                        iconPath={process.env.PUBLIC_URL + 'images/id-check-icon.svg'}
                        selectedIconPath={process.env.PUBLIC_URL+'images/id-check-icon-selected.svg'}
                        recommended={false}
                        secured={true}
                        navigateTo="/IdentityCheck"
                        isSelected={selectedOption==="/IdentityCheck"}
                        onSelect={handleCardSelect}
                        />

                    <CheckCard renderer={contains(options, "OpenBanking")}
                        name={t("checkOptions.card.openBanking.title")} 
                        description={t("checkOptions.card.openBanking.desc")} 
                        description2={t("checkOptions.card.openBanking.desc2")}
                        iconPath={process.env.PUBLIC_URL + 'images/open-banking-icon.svg'}
                        selectedIconPath={process.env.PUBLIC_URL+'images/open-banking-icon-selected.svg'}
                        recommended={true}
                        secured={true}
                        navigateTo="/OpenBankingStart"
                        isSelected={selectedOption==="/OpenBankingStart"}
                        onSelect={handleCardSelect}
                        />
                    
                    <CheckCard renderer={contains(options, "BankTransfer")}
                        name={t("checkOptions.card.bankingTransfer.title")} 
                        description={t("checkOptions.card.bankingTransfer.desc")}
                        description2={t("checkOptions.card.bankingTransfer.desc2")} 
                        iconPath={process.env.PUBLIC_URL+'images/bank-transfer-icon.svg'}
                        selectedIconPath={process.env.PUBLIC_URL+'images/bank-transfer-icon-selected.svg'}
                        recommended={false}
                        secured={true}
                        navigateTo="/BankingTransferStart"
                        isSelected={selectedOption==="/BankingTransferStart"}
                        onSelect={handleCardSelect}
                        />
                </div>  
            }  

            

            {isResourceLoaded && isTransactionProcessing && isEmpty(error) &&
                <div className="row mt-4 mb-5">
                    <input type="checkbox" id="gdpr-agreement-id" className="az-pay-CB" 
                        defaultChecked={IsGDPRAccepted} onChange={handleGdprAgreement}/>
                    <label className="az-pay-agreement-label" htmlFor="gdpr-agreement-id">
                        {t("checkOptions.gdpr.agreement1")}
                        <span className="az-pay-notice">
                            <a href={currentPrivacyNoticeUrl} target="_blank" rel="noreferrer"> 
                                {t("checkOptions.gdpr.privacy")}
                            </a>
                    </span>
                    </label>
                </div>
            }

            { showGdprMessageMandatory && 
                <div className="small-font error-message">
                    {t('checkOptions.gdpr.requiredMessage')}
                </div>
            }
            
            { isResourceLoaded && isTransactionProcessing &&  isEmpty(error) && 
                <div>
                    <button className={`az-btn ${!IsGDPRAccepted || !selectedOption ? "disabled" :""} `}  onClick={handleContinue}>
                        {t("checkOptions.card.continue.label")}
                    </button>
                </div>
            }              

        <Back renderer={isResourceLoaded} message={t('checkOptions.back.link')} />

        </Layout>

    );
  }

export default CheckOptions;